import angular from 'angular';
import InlineCheckComponent from './inline-check.component';

const InlineCheckModule = angular
    .module('control-room.commons.form.components.inline-check', [])
    .component('crInlineCheck', InlineCheckComponent);

export default InlineCheckModule;
